import { FiltersType, ListingRequest } from '@/api/types';
import { client } from '@/client';
import { Manager } from '@/client/accounts';
import { PartialRequestMultiselect } from '@/components/form/generic/PartialRequestMultiselect';
import { useAppSelector } from '@/hooks/store';
import { selectCurrentAccount } from '@/store/features/account';
import React, { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

type ManagersEmailMultiselectInputProps = {
  onChange: (value: Manager[]) => void;
  onBlur?: () => void;
  additionalFilters?: FiltersType;
  selectedOptions?: Manager[];
  isDisabled?: boolean;
  accountId?: string;
} & Omit<HTMLAttributes<HTMLSelectElement>, 'onChange' | 'defaultChecked'>;

export const ManagersEmailMultiselectInput: React.FC<
  ManagersEmailMultiselectInputProps
> = ({
  onChange,
  onBlur,
  className,
  additionalFilters,
  selectedOptions,
  isDisabled,
  accountId,
}) => {
  const { t } = useTranslation();
  const currentAccount = useAppSelector(selectCurrentAccount);

  const fetchManagers = isDisabled
    ? undefined
    : async (params: ListingRequest) => {
        const managers = await client.accountEntities.getManagers(
          params,
          accountId || currentAccount?.id || '',
        );

        const filterEmptyValues = managers.filter(
          (manager) => !!manager.email?.trim(),
        );

        return filterEmptyValues;
      };

  return (
    <PartialRequestMultiselect
      dataKey="email"
      fetchService={fetchManagers}
      filter
      display="chip"
      optionLabel="email"
      filterBy="email"
      placeholder={t('generic.select')}
      maxSelectedLabels={10}
      additionalFilters={additionalFilters}
      selectedOptions={selectedOptions}
      className={className}
      handleOnChange={onChange}
      onBlur={onBlur}
      disabled={isDisabled}
      isNotListingResponse
    />
  );
};
